import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductProductStatusAsync,
  deleteProductProductStatusAsync,
  editProductStyleAsync,
  editProductProductStatusAsync,
  getProductStyleAsync,
  getProductProductStatusAsync,
} from "../../../../store/services/productInfoServices";
const ProductStatus = () => {
  const dispatch = useDispatch();
  const {
    getProductProductStatusStatus,
    getProductProductStatusError,
    getProductProductStatusData,
    addProductProductStatusStatus,
    addProductProductStatusData,
    addProductProductStatusError,

    editProductProductStatusStatus,
    editProductProductStatusError,
    editProductProductStatusData,

    deleteProductProductStatusData,
    deleteProductProductStatusStatus,
    deleteProductProductStatusError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductProductStatusAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductProductStatusData?.length
    ? getProductProductStatusData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedProductStatus, setSelectedProductStatus] = useState();
  const [addProductStatusMode, setAddProductStatusMode] = useState(false);
  const [addProductStatusData, setAddProductStatusData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedProductStatus", selectedProductStatus);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductProductStatusStatus === asyncStatus.SUCCEEDED) {
      setAddProductStatusMode(false);
      setSaveDisabled(true);
      setAddProductStatusData();
    }
  }, [, addProductProductStatusStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductProductStatusAsync(selectedProductStatus?.product_status_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductProductStatusStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedProductStatus();
    }
  }, [, deleteProductProductStatusStatus]);
  useEffect(() => {
    if (editProductProductStatusStatus === asyncStatus.SUCCEEDED) {
      setSelectedProductStatus();
      setEditMode(false);
    }
  }, [, editProductProductStatusStatus]);
console.log("getProductProductStatusData",getProductProductStatusData,editProductProductStatusData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this ProductStatus?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Product Status"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Product Status Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddProductStatusMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addProductStatusMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductStatusMode || !selectedProductStatus}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddProductStatusMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addProductStatusMode || !selectedProductStatus}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductProductStatusStatus === asyncStatus.LOADING ||
                  editProductProductStatusStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addProductStatusData) {
                    dispatch(addProductProductStatusAsync(addProductStatusData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedProductStatus, ...editData };
                    delete a.id;
                    dispatch(editProductProductStatusAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "product_status_id", headerName: "ID", flex: true },
                  {
                    field: "product_status_name",
                    headerName: "Product Status Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedProductStatus(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductProductStatusStatus === asyncStatus.IDLE ||
                  getProductProductStatusStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addProductStatusMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Product Status:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddProductStatusData({
                            ...addProductStatusData,
                            product_status_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddProductStatusData({
                            ...addProductStatusData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedProductStatus ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedProductStatus?.product_status_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "ProductStatus:",
                    comp: (
                      <InputComp
                        key={selectedProductStatus?.product_status_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            product_status_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedProductStatus?.product_status_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedProductStatus?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedProductStatus?.is_active ? true : false
                        }
                        checked={selectedProductStatus?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any product status</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductProductStatusError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductProductStatusError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductProductStatusError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductProductStatusError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedProductStatus(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedProductStatus(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default ProductStatus;
